import React, { useState } from 'react';
import { useTranslator } from 'tradera-lang/translate';
import { ShareModal } from 'tradera-components/share-modals/share-modal';
import { Button } from 'tradera-components/atoms/button/button';
import ShareIcon from '@tradera/blueprint/theme/icons2/share.svg?jsx';

const translationKeys = {
    shareHeader: 'profile_shareHeader',
    shareMailSubject: 'profile_shareViaMailSubject',
    shareMailBody: 'profile_shareViaMailBody',
    sharePinterestDescription: 'profile_shareViaPinterestDescription',
    shareLinkText: 'profile_shareLink'
};

const ProfileShareButton = ({ profileData }) => {
    const { t } = useTranslator();
    const [showShareModal, setShowShareModal] = useState(false);

    const { cleanedAlias, heroImageUrl } = profileData;

    return (
        <>
            <Button
                theme="dark"
                outline
                fluid
                className="font-weight-bold text-styled"
                onClick={() => setShowShareModal(true)}>
                <ShareIcon className="icon mr-2 ml-n1" />
                {t('profileHeader_share')}
            </Button>
            {showShareModal && (
                <ShareModal
                    gaCategory="Profile"
                    shareTitle={cleanedAlias}
                    shareImageUrl={heroImageUrl}
                    translationKeys={translationKeys}
                    onDismiss={() => setShowShareModal(false)}
                />
            )}
        </>
    );
};

export { ProfileShareButton };
